import { connect } from 'react-redux';
import Campaign from '../component/Campaign';
import actions from '../redux/actions/campaign';

const mapStateToProps = (state) => ({
  campaign: state.campaign.campaign,
});

const mapDispatchToProps = (dispatch) => ({
  fetchAllCampaign: (params, callback) => {
    dispatch(actions.onFetchAllCampaignAction(params, callback));
  },
  addCampaignAction: (params, callback1, callback2 = () => {}) => {
    dispatch(actions.onAddCampaignAction(params, callback1, callback2));
  },
  updateCampaignAction: (params, callback1, callback2 = () => {}) => {
    dispatch(actions.onUpdateCampaignAction(params, callback1, callback2));
  },
  deleteCampaignAction: (params, callback1, callback2 = () => {}) => {
    dispatch(actions.onDeleteCampaignAction(params, callback1, callback2));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(Campaign);
